/** Tetapan → Perancangan → Pemberitahuan, log penghantaran dan Keutamaan e-mel (perancangan P4-1a, reka bentuk §5.7, §5.8). */
export default {
  notifications: {
    title: 'Pemberitahuan',
    description:
      'Hantar e-mel kepada pemohon, pegawai dan jabatan teknikal tentang perkara yang berlaku pada kes mereka. E-mel mengandungi rujukan, tarikh, nama langkah, nama majlis dan pautan; tiada yang lain.',
    enabled: 'Hantar pemberitahuan e-mel',
    enabledHint:
      'Dimatikan secara lalai. Hanya perkara yang berlaku selepas anda menghidupkannya akan dihantar melalui e-mel.',
    enableNeedsTest: 'Hantar e-mel ujian kepada diri anda dahulu, menggunakan butang di bawah.',
    enabledSince: 'Dihidupkan sejak {{date}}.',
    modesTitle: 'Cara setiap e-mel dihantar',
    kinds: {
      applicant_update: 'Kemas kini kepada pemohon',
      applicant_document_shared: 'Dokumen yang dikongsi dengan pemohon',
      applicant_reminder: 'Peringatan kepada pemohon',
      officer_work: 'Kerja untuk pegawai',
      officer_referral_answered: 'Ulasan teknikal diterima',
      officer_reminder: 'Peringatan kepada pegawai',
      department_referral: 'Permohonan ulasan teknikal',
      department_reminder: 'Peringatan kepada jabatan',
      test: 'E-mel ujian',
      digest: 'Ringkasan harian',
    },
    modes: { off: 'Dimatikan', immediate: 'Serta-merta', digest: 'Dalam ringkasan harian' },
    offsetsTitle: 'Peringatan',
    offsetsHint: 'Bilangan hari sebelum tarikh, dipisahkan dengan koma.',
    offsetsApplicant: 'Hari sebelum tarikh maklum balas',
    offsetsLapse: 'Hari sebelum kebenaran luput',
    appealDates: 'Sertakan tarikh rayuan',
    appealDatesHint: 'Apabila dimatikan, e-mel dan peringatan tidak menyebut tempoh rayuan.',
    digestHour: 'Jam ringkasan harian (0 hingga 23)',
    defaultLocale: 'Bahasa apabila seseorang belum memilih',
    locales: { en: 'Bahasa Inggeris', ms: 'Bahasa Melayu', zh: 'Bahasa Cina' },
    replyTo: 'Alamat Balas Kepada',
    replyToHint: 'Balasan dihantar ke peti mel ini, contohnya peti mel OSC majlis.',
    problems: {
      offsets: 'Hari genap dari {{min}} hingga {{max}}, paling banyak tiga, tiada yang berulang.',
      digestHour: 'Masukkan jam genap dari 0 hingga 23.',
      replyTo: 'Masukkan satu alamat e-mel.',
    },
    save: 'Simpan pemberitahuan',
    saving: 'Menyimpan…',
    saved: 'Tetapan pemberitahuan disimpan.',
    log: {
      title: 'Log penghantaran',
      senderLabel: 'Perkhidmatan mel',
      senderSes: 'Dihantar melalui Amazon SES',
      senderSmtp: 'Dihantar melalui geganti mel anda',
      relayNoFeedback: 'Geganti mel anda tidak melaporkan lantunan: Dihantar bermaksud geganti telah menerima mesej.',
      noRelay: 'Tiada geganti mel dikonfigurasikan',
      countsLabel: 'Mesej mengikut status',
      awaitingDigest: 'Menunggu ringkasan',
      awaitingDigestHint: 'Mesej ringkasan menunggu di sini sehingga ringkasan harian seterusnya dihantar.',
      held: 'Ditahan untuk surat',
      heldListLabel: 'Keputusan yang menunggu surat',
      heldItem: '{{caseRef}}: keputusan pada langkah {{step}}',
      overCap: 'Melebihi had penerima',
      failuresLabel: 'Kegagalan mengikut sebab',
      failure: 'Sebab "{{reason}}": {{count}}',
      filterLabel: 'Rujukan kes',
      filter: 'Tapis',
      clearFilter: 'Kosongkan tapisan',
      columns: {
        kind: 'E-mel',
        caseRef: 'Kes',
        recipient: 'Penerima',
        status: 'Keadaan',
        attempts: 'Cubaan',
        created: 'Dicipta',
        action: 'Tindakan',
      },
      empty: 'Belum ada mesej yang dilog.',
      more: 'Tunjukkan lagi',
      resend: 'Hantar semula',
      resendLabel: 'Hantar semula e-mel kepada {{address}}',
    },
    statuses: {
      queued: 'Dalam giliran',
      sent: 'Dihantar',
      failed: 'Gagal',
      suppressed: 'Tidak dihantar',
      bounced: 'Melantun',
      complained: 'Ditanda sebagai spam',
    },
    codes: {
      not_visible: 'Orang itu tidak lagi dapat melihat kes ini',
      opted_out: 'Orang itu telah mematikan e-mel ini',
      no_address: 'Orang itu tiada alamat e-mel',
      address_suppressed: 'Alamat ini pernah melantun atau membuat aduan',
      not_configured: 'Tiada geganti mel dikonfigurasikan',
      no_link_base: 'Tiada alamat konsol untuk dipautkan',
      over_cap: 'Terlalu ramai penerima',
      stale: 'Terlalu lama untuk dihantar',
      throttled: 'Perkhidmatan mel meminta supaya diperlahankan',
      rejected: 'Ditolak oleh perkhidmatan mel',
      invalid_address: 'Alamat tidak sah',
      auth_failed: 'Perkhidmatan mel menolak kelayakan',
      timeout: 'Perkhidmatan mel tidak menjawab dalam masa',
      unavailable: 'Perkhidmatan mel tidak dapat dihubungi',
      unknown: 'Kegagalan perkhidmatan mel yang tidak diketahui',
    },
    test: {
      send: 'Hantar e-mel ujian kepada saya',
      sending: 'Menghantar…',
      sent: 'E-mel ujian dihantar kepada {{address}}.',
      failed: 'E-mel ujian tidak dihantar: {{reason}}.',
    },
    unavailable: {
      not_configured: 'Tiada geganti mel dikonfigurasikan, jadi e-mel ujian tidak boleh dihantar.',
      no_address: 'Akaun anda tiada alamat e-mel untuk menerima ujian.',
      not_tenant_identity:
        'Akaun anda bukan milik ruang kerja ini. Log masuk dengan salah satu akaunnya untuk menghantar ujian.',
      settings_not_saved: 'Simpan tetapan Perancangan dahulu, kemudian hantar e-mel ujian.',
      no_link_base: 'Pemasangan ini tiada alamat konsol untuk dipautkan, jadi tiada e-mel dapat sampai kepada sesiapa.',
    },
    preferences: {
      open: 'Keutamaan e-mel',
      title: 'Keutamaan e-mel',
      intro: 'Pilih e-mel perancangan yang anda terima. Mematikan e-mel tidak menyembunyikan apa-apa dalam konsol.',
      updates: 'Kemas kini tentang kes saya',
      reminders: 'Peringatan tarikh',
      digests: 'Ringkasan harian',
      lastChanged: 'Kali terakhir ditukar {{date}}.',
      save: 'Simpan',
      saving: 'Menyimpan…',
      cancel: 'Batal',
    },
  },
  errors: {
    notifications_test_required: 'Hantar e-mel ujian kepada diri anda sebelum menghidupkan pemberitahuan.',
    notification_test_unavailable:
      'E-mel ujian tidak boleh dihantar: tiada geganti mel disediakan, atau akaun anda tiada alamat.',
    notification_test_limit: 'Paling banyak lima e-mel ujian sejam. Cuba lagi kemudian.',
    notification_not_found: 'Mesej itu tidak ditemui.',
    notification_not_resendable: 'Hanya mesej yang gagal atau terlalu lama boleh dihantar semula.',
    notifications_off: 'Pemberitahuan dimatikan. Hidupkan dahulu untuk menghantar semula mesej.',
  },
} as const
